import styled, { css } from "styled-components";
import { pxToRem } from "../../styles/utils";
import type { TooltipPlacement } from "./Tooltip.types";

export const TooltipTrigger = styled.span<{ $block: boolean }>`
  display: ${({ $block }) => ($block ? "block" : "inline-flex")};
  min-width: 0;
  max-width: 100%;
`;

export const TooltipBubble = styled.div<{
  $placement: TooltipPlacement;
  $maxWidth: string;
  $positioned: boolean;
}>`
  position: fixed;
  z-index: 10000;
  box-sizing: border-box;
  max-width: ${({ $maxWidth }) => $maxWidth};
  padding: ${pxToRem(8)} ${pxToRem(10)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.inkBorder};
  border-radius: ${pxToRem(8)};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.ink};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  font-size: ${pxToRem(13)};
  font-weight: 400;
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: anywhere;
  pointer-events: none;
  visibility: ${({ $positioned }) => ($positioned ? "visible" : "hidden")};

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-style: solid;
    border-color: transparent;
    pointer-events: none;
  }

  &::before {
    border-width: ${pxToRem(6)};
  }

  &::after {
    border-width: ${pxToRem(5)};
  }

  ${({ $placement, theme }) =>
    $placement === "top"
      ? css`
          &::before {
            top: 100%;
            border-top-color: ${theme.colors.inkBorder};
          }

          &::after {
            top: calc(100% - ${pxToRem(1)});
            border-top-color: ${theme.colors.white};
          }
        `
      : css`
          &::before {
            bottom: 100%;
            border-bottom-color: ${theme.colors.inkBorder};
          }

          &::after {
            bottom: calc(100% - ${pxToRem(1)});
            border-bottom-color: ${theme.colors.white};
          }
        `}
`;
